@if (isVerifying) {
<div class="verification-screen">
  <div class="verification-content">
    <div class="spinner-container">
      <svg class="spinner" viewBox="0 0 50 50">
        <circle class="spinner-path" cx="25" cy="25" r="20" fill="none" stroke-width="3"></circle>
        <circle class="spinner-dot" cx="25" cy="5" r="3" fill="#04a251"></circle>
      </svg>
    </div>
    <h2 class="verification-title">Verifying Authorization...</h2>
    <p class="verification-subtitle">SECURE ACCESS GATEWAY</p>
  </div>
</div>
}

@if (!isVerifying) {
<mat-card id="page-content" class="rtl">
  <div class="header-container">
    <div class="row justify-content-between">
      <div class="col-md-4 col-12">
        <mat-card-title>{{ "VIEW_COMPLAINT" | translate }}</mat-card-title>
      </div>
      <div class="col-md-2 col-12 d-flex justify-content-end">
        <button mat-button class="btn-secondary print-button" color="primary" (click)="downloadPdf('complaint.pdf')">
          <mat-icon>print</mat-icon>
          Print
        </button>

      </div>
    </div>
  </div>
  <mat-card-content class="search-form">
    <span>
      <b>{{ "COMPLAINT_NO" | translate }}</b>: {{ complaint?.complaintNo }}</span>
    <span style="float: right"><b>{{ "STATUS" | translate }}</b>: {{ complaint?.currentProcess?.name }}</span>
    <form class="form-container" [formGroup]="form">
      @if (canSeeInfo) {
      <div class="dragCardsHeading m-0">
        <div class="col-8 p-0">
          <h2 class="dragCardsHeading m-0">
            {{ "CITIZEN_DETAILS" | translate }}
          </h2>
        </div>
        <div class="col-4 text-end" style="padding: 10px;">
          @if (canViewAnonymousInfo && complaint?.isAnonymous) {
            <button mat-raised-button color="primary"
                    (click)="getPersonalInfo(complaint?.complaintId)">
              Reveal
            </button>
          }
        </div>
      </div>
      <div class="row">
        <mat-card-content class="search-form">
          <mat-form-field appearance="outline">
            <mat-label>{{ "COMPLAINANT_NAME" | translate }}</mat-label>
            <input class="padding" matInput formControlName="name" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "GENDER" | translate }}</mat-label>
            <input matInput formControlName="gender" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "CNIC" | translate }}</mat-label>
            <input matInput formControlName="cnic" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "PHONE" | translate }}</mat-label>
            <input matInput formControlName="cellPhoneNo" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "EMAIL" | translate }}</mat-label>
            <input class="padding" matInput formControlName="email" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "Passport no" | translate }}</mat-label>
            <input matInput formControlName="passportNo" />
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "ADDRESS" | translate }}</mat-label>
            <textarea matInput formControlName="address" rows="3" style="resize: none;"></textarea>
          </mat-form-field>
          <mat-checkbox formControlName="isAnonymous">{{
            "KEEP_ME_ANONYMOUS" | translate
            }}</mat-checkbox>
        </mat-card-content>
      </div>
      }
      <div class="row">
        <div class="col-12 p-0">
          <h2 class="dragCardsHeading">
            {{ "Complaint Details" | translate }}
          </h2>
        </div>
      </div>

      <div class="row">
        <mat-card-content class="search-form">
          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "SEGMENT" | translate }}</mat-label>
            <mat-select formControlName="segmentId">
              <mat-option [value]="1">PULSE</mat-option>
              <mat-option [value]="2">PLRA</mat-option>
            </mat-select>
            @if (f['segmentId'].errors) {
            <mat-error>
              @if (f['segmentId'].errors['required']) {
              <span>{{ "FIELD_REQUIRED" | translate }}</span>}
            </mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "PRIORITY" | translate }}</mat-label>
            <mat-select formControlName="priority">
              <mat-option [value]="'LOW'">Low</mat-option>
              <mat-option [value]="'MEDIUM'">Medium</mat-option>
              <mat-option [value]="'HIGH'">High</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "SEVERITY" | translate }}</mat-label>
            <mat-select formControlName="severity">
              <mat-option [value]="'EASY'">Easy</mat-option>
              <mat-option [value]="'MEDIUM'">Medium</mat-option>
              <mat-option [value]="'COMPLEX'">Complex</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "COMPLAINT_TYPE" | translate }}</mat-label>
            <input class="padding" matInput formControlName="complaintCategoryName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "COMPLAINT_SUBTYPE" | translate }}</mat-label>
            <input class="padding" matInput formControlName="complaintSubcategoryName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "DIVISION" | translate }}</mat-label>
            <input class="padding" matInput formControlName="divisionName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "DISTRICT" | translate }}</mat-label>
            <input class="padding" matInput formControlName="districtName" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "TEHSIL" | translate }}</mat-label>
            <input class="padding" matInput formControlName="tehsilName" />
          </mat-form-field>
          <mat-form-field appearance="outline" class="bold-border" floatLabel="always">
            <mat-label>{{ "MOUZA" | translate }}</mat-label>
            @if (isMouzaLoading) {
              <mat-select formControlName="mouzaId" size="small" class="padding" [disabled]="true">
                <mat-option [disabled]="true">{{ "Loading..." | translate }}</mat-option>
              </mat-select>
            } @else {
              <mat-select formControlName="mouzaId" size="small" (selectionChange)="clearMouzaSearch()" class="padding">
                <!-- Input field for searching -->
                <input #searchMouza id="search-select-mouza" class="w-100 border-0 p-3"
                  placeholder="Search {{ 'MOUZA' | translate }}" (keyup)="filterMouza($event)" />
                <!-- Display options -->
                @for (ct of mouzaList; track $index) {
                <mat-option [value]="ct.adminStrId">
                  {{ ct.name }}
                </mat-option>
                }
              </mat-select>
            }
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "COMPLAINT_ADDRESS" | translate }}</mat-label>
            <textarea matInput formControlName="complaintAddress" rows="3" style="resize: none;"></textarea>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "DAYS_REQUIRED" | translate }}</mat-label>
            <input matInput formControlName="daysRequired" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "LEGAL_FRAMEWORK" | translate }} </mat-label>
            <input class="padding" matInput formControlName="legalFramework" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "EXPECTD_RESOLUTION_DATE" | translate }}</mat-label>
            <input matInput value="{{
                f['expectedResolutionDate'].value | date : 'dd-MM-yyyy'
              }}" disabled />
            <!-- <mat-label>{{f['expectedResolutionDate']!.value | date: 'dd-MM-yyyy'}}</mat-label> -->
          </mat-form-field>
          @if (['closed', 'appeal closed', 'drop'].includes(complaint?.currentProcess?.name?.toLowerCase() || '')) {
          <mat-form-field appearance="outline">
            <mat-label>{{ "STATUS" | translate }}</mat-label>
            <input matInput [value]="complaint?.currentProcess?.name" disabled style="color: rgba(0, 0, 0, 0.38);" />
          </mat-form-field>
          } @else {
          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "STATUS" | translate }}</mat-label>
            <mat-select class="padding" formControlName="currentProcessId">
              <mat-option [value]="complaint?.currentProcess?.complaintProcessId">{{ complaint?.currentProcess?.name
                }}</mat-option>
              @for (ct of complaintProcessSuccessorList;track ct) {
              <mat-option [value]="ct.complaintProcessId">{{
                ct.name
                }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }

          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "ASSIGN_TO" | translate }}</mat-label>
            <mat-select class="padding" formControlName="assignTo">
              @for (ct of usersList;track ct) {
              <mat-option [value]="ct['userId']">{{ ct['userName'] }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="bold-border">
            <mat-label>{{ "ASSIGN_TO_GROUP" | translate }}</mat-label>
            <mat-select class="padding" formControlName="assignToGroup">
              @for (ct of groupsList;track ct) {
              <mat-option [value]="ct.groupId">{{ ct.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>{{ "OTHER_FORUM" | translate }}</mat-label>
            <textarea matInput formControlName="otherForum" rows="3" style="resize: none;"></textarea>
          </mat-form-field>
          <div class="col-12 p-0">
            <h2 class="dragCardsHeading">{{ "DESCRIPTION" | translate }}</h2>
          </div>
          <div>
            <ngx-editor [editor]="editor" formControlName="complaintDetails"
              placeholder="{{ 'DESCRIPTION' | translate }}"></ngx-editor>
          </div>
          <!-- <mat-form-field appearance="outline" class="textarea" >
                        <mat-label>{{'DESCRIPTION' | translate}} </mat-label>
                        <textarea matInput formControlName="complaintDetails" size="large" style="padding: 10px 1px 0 1px"></textarea>
                    </mat-form-field> -->
        </mat-card-content>
      </div>

      <div class="row">
        <div class="col-12 p-0">
          <h2 class="dragCardsHeading">
            {{ "ADDITIONAL_DETAIL" | translate }}
          </h2>
        </div>
      </div>
      <div class="row">
        <mat-card-content class="search-form">
          <mat-form-field appearance="outline">
            <mat-label>{{ "Work Code" | translate }}</mat-label>
            <input matInput formControlName="workCode" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "HELPLINE_IDENTIFIER" | translate }} </mat-label>
            <input matInput formControlName="helplineIdentifier" />
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>{{ "SOURCE" | translate }}</mat-label>
            <input matInput formControlName="complaintSource" />
          </mat-form-field>
          @if (f['complaintSource'].value === 'Other') {
          <mat-form-field appearance="outline">
            <mat-label>{{ "OTHER_SOURCE" | translate }}</mat-label>
            <input matInput formControlName="otherSource" />
          </mat-form-field>
          }
        </mat-card-content>
      </div>
      <div class="row" id="attachements">
        <div class="col-12 p-0">
          <h2 class="dragCardsHeading">
            {{ "ADD_ATTACHMENTS_TITLE" | translate }}
          </h2>
        </div>
      </div>

      <div class="row" id="attachements-files">
        <div class="col-md-12 ps-0">
          @if (documentList.length > 0) {
            <div class="attachment-count">{{ documentList.length }} {{ (documentList.length === 1 ? 'ATTACHMENT' : 'ATTACHMENTS') | translate }}</div>
            @for (d of documentList; track d; let index = $index) {
            <div class="attachment-card">
              <div class="attachment-info">
                <mat-icon [class]="d?.documentType === 'application/pdf' ? 'attachment-icon pdf' : 'attachment-icon image'">
                  {{ d?.documentType === 'application/pdf' ? 'picture_as_pdf' : 'image' }}
                </mat-icon>
                <span class="attachment-name" [title]="d?.documentName">{{ truncateText(d?.documentName, 35) }}</span>
              </div>
              <div class="attachment-actions">
                <button mat-icon-button color="primary" matTooltip="{{ 'PREVIEW' | translate }}" (click)="preview(d.complaintDocumentId)">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button matTooltip="{{ 'DOWNLOAD' | translate }}" (click)="download(d.complaintDocumentId)">
                  <mat-icon>download</mat-icon>
                </button>
                @if (d?.createdBy === userId) {
                  <span class="attachment-divider"></span>
                  <mat-checkbox [(ngModel)]="d.isPublished" [disabled]="d?.isCitizenDocument || isAttachmentDisabled()"
                    [ngModelOptions]="{ standalone: true }" (change)="!isAttachmentDisabled() && updateIsPublished(d)">
                    {{ "PUBLISHED" | translate }}
                  </mat-checkbox>
                  <button mat-icon-button class="remove-btn" matTooltip="{{ 'REMOVE' | translate }}"
                    [disabled]="isAttachmentDisabled()"
                    (click)="!isAttachmentDisabled() && removeAttachment(index, d?.complaintDocumentId)">
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                }
              </div>
            </div>
            }
          } @else {
            <div class="attachment-empty">
              <mat-icon>attach_file</mat-icon>
              <span>{{ "NO_ATTACHMENTS" | translate }}</span>
            </div>
          }
        </div>

        <div class="col-12 my-4">
          <input type="file" class="text-end btn-primary" [disabled]="isAttachmentDisabled()"
            [style.opacity]="isAttachmentDisabled() ? '0.5' : '1'"
            [style.cursor]="isAttachmentDisabled() ? 'not-allowed' : 'pointer'"
            (change)="!isAttachmentDisabled() && onSelectFile($event)" />

          @if (fileError) {
          <mat-error>
            <span style="color: red">{{
              "FILE_ATTACHMENT_ERROR" | translate
              }}</span>
          </mat-error>
          }
        </div>
      </div>

      <div class="row" id="reply-heading">
        <div class="col-12 p-0 ">
          <h2 class="dragCardsHeading">
            {{ "WRITE_REPLY" | translate }}
          </h2>
        </div>
      </div>
      <div class="editor " id="reply-content">
        <div class="">
          <ngx-editor-menu [editor]="commentsEditor" [toolbar]="commentstoolbar"></ngx-editor-menu>
          <ngx-editor [editor]="commentsEditor" formControlName="comment" placeholder="Write Here"></ngx-editor>
        </div>
      </div>

      <mat-grid-list cols="3" rowHeight="80px" id="form-extra">
        <button mat-raised-button class="mx-2" color="primary" [disabled]="
            form.invalid ||
            ['closed', 'appeal closed', 'drop'].includes(
              complaint?.currentProcess?.name?.toLowerCase() || ''
            )
          " (click)="confirmSave()">
          {{ "SAVE" | translate }}
        </button>
        <button mat-raised-button color="primary" (click)="confirmCancel()">
          {{ "CANCEL" | translate }}
        </button>

        @if (isValidMobile(complaint?.cellPhoneNo) && !isComplaintClosed()) {
        <button mat-raised-button class="mx-2" color="primary" [disabled]="form.invalid" (click)="sendSms()">
          {{ "SMS" | translate }}
        </button>
        }

        @if (isValidEmail(complaint?.email) && !isComplaintClosed()) {
        <button mat-raised-button class="mx-2" color="primary" [disabled]="form.invalid || complaint?.email === ''" (click)="sendEmail()">
          {{ "EMAIL_BUTTON" | translate }}
        </button>
        }
        <button mat-raised-button class="mx-2" color="primary" [disabled]="
            form.invalid ||
            ['closed', 'appeal closed', 'drop'].includes(
              complaint?.currentProcess?.name?.toLowerCase() || ''
            )
          " (click)="openDropModal()">
          {{ "DROP" | translate }}
        </button>

        @if (['closed'].includes(complaint?.currentProcess?.name?.toLowerCase() || '')) {
        <button mat-raised-button class="mx-2" color="primary" [disabled]="form.invalid || form.dirty"
          (click)="openAppealModal()">
          {{ "APPEAL" | translate }}
        </button>
        }

        @if (showGrmSpecialistButton()) {
        <button mat-raised-button class="mx-2" color="primary" (click)="openReopenModal()">
          {{ "REOPEN" | translate }}
        </button>
        }

        <!-- (click)="sendEmail('vcds','Dwsfd')" -->
      </mat-grid-list>

      <div class="row" id="activity-heading">
        <div class="col-12 p-0">
          <h2 class="dragCardsHeading">{{ "ACTIVITY" | translate }}</h2>
        </div>
      </div>

      <div class="row" id="activities">
        <div class="col-12">
          <ul class="timeline-list">
            @for (t of trackingList;track t) {
            <li>
              <div class="timeline_content">
                @if(t?.createdByName){
                <div class="row">
                  <p>

                    <b class="text-primary">{{ complaint?.isAnonymous && complaint?.complaintSource === 'citizen portal'
                      && t?.statusChangedName === 'Registered' ? 'Anonymous' : t?.createdByName }}</b> -
                    {{ t?.createdAt | date : "dd MMM yyyy hh:mm a" }}

                  </p>
                </div>
                } @if(t?.comment){
                <div class="row">
                  <p class="mb-0">
                    <b class="text-primary">{{ "COMMENTS" | translate }}:</b>
                    <span [innerHTML]="t?.comment"></span>
                  </p>
                </div>
                } @if(t?.statusChangedName){
                <div class="row">
                  <p>
                    <b class="text-primary">Status:</b>
                    {{ t?.statusChangedName }}
                  </p>
                </div>
                } @if(t?.priorityChanged){
                <div class="row">
                  <p>
                    <b class="text-primary">Priority:</b>
                    {{ t?.priorityChanged }}
                  </p>
                </div>
                } @if(t?.severityChanged){
                <div class="row">
                  <p>
                    <b class="text-primary">Severity:</b>
                    {{ t?.severityChanged }}
                  </p>
                </div>
                }@if(t?.documentName && t.isRemove === true){
                <div class="row">
                  <p>
                    <b class="text-primary">Document Removed:</b>
                    {{ t?.documentName }}
                  </p>
                </div>
                }
                @if(t?.documentName && t.isRemove === null ){
                <div class="row">
                  <p>
                    <b class="text-primary">Document Attached:</b>
                    {{ t?.documentName }}
                  </p>
                </div>
                } @if(t?.complaintEmailMessage){
                <div class="row">
                  <p>
                    <b class="text-primary">Email: </b>
                    {{ t?.complaintEmailMessage }}
                  </p>
                </div>
                } @if(t?.complaintSMSMessage){
                <div class="row">
                  <p>
                    <b class="text-primary">SMS: </b>
                    {{ t?.complaintSMSMessage }}
                  </p>
                </div>
                } @if(t?.assignedToName){
                <div class="row">
                  <p>
                    <b class="text-primary">Assigned To: </b>
                    {{ t?.assignedToName }}
                  </p>
                </div>
                } @if(t?.assignedToGroupName){
                <div class="row">
                  <p>
                    <b class="text-primary">Assigned To Group: </b>
                    {{ t?.assignedToGroupName }}
                  </p>
                </div>
                }
              </div>
            </li>
            }
          </ul>
        </div>
      </div>
    </form>
  </mat-card-content>
</mat-card>
}